import { Campaign, Collab, MAX_COLLAB_COUNTERS } from '@foodfluence/shared';

/** The server enforces the same limit (shared constant). */
export const MAX_COUNTERS = MAX_COLLAB_COUNTERS;

export const canCounter = (campaign: Campaign, collab: Collab): boolean => {
  return campaign?.allowCounters && (collab.counters?.length ?? 0) < MAX_COUNTERS;
};